<ejs-grid #grid
          class="grid-with-footer"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [allowFiltering]="true"
          [filterSettings]="filterSettings"
          [allowPaging]="true"
          [pageSettings]="pageSettings"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          [showColumnChooser]='true'
          [toolbar]='toolbarOptions'
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"
              headerText="{{'i18n.shared.fields.id' | translate}}"
              [showInColumnChooser]="false">
    </e-column>
    <e-column field="registrationDateTime"
              type="date"
              [filter]="dateFilter"
              headerText="{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}"
              clipMode="EllipsisWithTooltip"
              width="155px">
      <ng-template #template let-data>
        {{data.registrationDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
      </ng-template>
    </e-column>
    <e-column field="parkingSessionId"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.parkingSessionId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="type"
              headerText="{{'i18n.domain.parker-registration.fields.type' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="registrationTypeFilter">
      <ng-template #template let-data>
        {{ formatRegistrationType(data) | translate}}
      </ng-template>
      <ng-template #filterItemTemplate let-data>
        {{ formatRegistrationType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column type="string"
              field="knownTag.parker.firstName"
              headerText="{{'i18n.domain.parker-registration.fields.parker-firstname' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="knownTag.parker.lastName"
              headerText="{{'i18n.domain.parker-registration.fields.parker-lastname' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="knownTag.parker.identification"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.parker-identification' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="knownTag.parker.company.name"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.company' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.parker.title"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.title' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="{{controlPlateField}}"
              [allowSorting]="false"
              headerText="{{'i18n.domain.parker-registration.fields.plate' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{getControlPlate(data)}}</span>
      </ng-template>
    </e-column>
    <e-column field="knownTag.controlPlateType"
              headerText="{{'i18n.domain.parker-registration.fields.control-plate-type' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="controlPlateTypeFilter"
              [visible]="false">
      <ng-template #template let-data>
        {{ formatControlPlateType(data) | translate}}
      </ng-template>
      <ng-template #filterItemTemplate let-data>
        {{ formatControlPlateType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column type="string"
              field="knownTag.countryCode"
              headerText="{{'i18n.domain.parker-registration.fields.country' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{getCountryCode(data)}}</span>
      </ng-template>
    </e-column>
    <e-column field="knownTag.barcode"
              type="string"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.barcode' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.identificationCode"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.knownTagId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.description"
              type="string"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.description' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.active"
              [visible]="false"
              [filter]="activeFilter"
              width="80px"
              headerText="{{'i18n.domain.parker-registration.fields.active' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="e-icons" [class.icon-checkmark]="data.knownTag.active"></span>
      </ng-template>
    </e-column>
    <e-column field="knownTag.defect"
              [visible]="false"
              [filter]="defectFilter"
              width="80px"
              headerText="{{'i18n.domain.parker-registration.fields.defect' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="e-icons" [class.icon-checkmark]="data.knownTag.defect"></span>
      </ng-template>
    </e-column>

    <e-column type="string"
              field="registeredByZoneDeviceName"
              headerText="{{'i18n.domain.parker-registration.fields.registeredByZoneDeviceId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="registeredByUserAgent.firstname"
              headerText="{{'i18n.domain.parker-registration.fields.agent-firstname' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="registeredByUserAgent.lastname"
              headerText="{{'i18n.domain.parker-registration.fields.agent-lastname' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string"
              field="registeredZoneName"
              headerText="{{'i18n.domain.parker-registration.fields.zone' | translate}}"
              clipMode="EllipsisWithTooltip"
              [showInColumnChooser]="true">
    </e-column>
    <e-column field="offense"
              headerText="{{'i18n.domain.parker-registration.fields.offense' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="offenseCheckboxFilter">
      <ng-template #template let-data>
        {{ formatOffenseType(data) | translate}}
      </ng-template>
      <ng-template #filterItemTemplate let-data>
        {{ formatOffenseType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column headerText=""
              width="70px"
              [showInColumnChooser]="false">
      <ng-template #template let-data>
        <span class="icon-warning--alt--filled text-danger me-2" *ngIf="data.offense !== ParkerRegistrationOffense.NoOffense"></span>
        <span class="icon-currency--dollar" [ngClass]="{'price--line-through': (data.penaltyState == penaltyStateCancelled)}" *ngIf="data.penaltyIssued"></span>
      </ng-template>
    </e-column>
    <e-column headerText=""
              width="60px"
              [commands]="gridCommands"
              [showInColumnChooser]="false">
    </e-column>
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-parker-registration-raw-detail [data]="data" [zones]="zones"></app-parker-registration-raw-detail>
  </ng-template>
</ejs-grid>
